import { gql } from '@apollo/client';
import UPDATE_CLASSROOM_SETTING_FRAGMENT from '../../fragments/update-classroom-setting-fragment';

const UPDATE_KEY_CLASSROOM_STOP_AND_REVIEW_SETTING = gql`
  mutation updateKeyClassroomSettingStopAndReview(
    $data: [UpdateKeyClassroomSettingStopAndReviewInput!]!
  ) {
    updateKeyClassroomSettingStopAndReview(data: $data) {
      ...UpdateClassroomSettingFragment
    }
  }
  ${UPDATE_CLASSROOM_SETTING_FRAGMENT}
`;

export default UPDATE_KEY_CLASSROOM_STOP_AND_REVIEW_SETTING;
